/*
 * volca-cart-consent.js
 * カートページの「規約・プライバシー同意」チェックボックスを購入ボタンのゲートにする。
 *
 * 使い方: 管理画面のカスタム Liquid ブロックに id="volca-cart-consent" のチェックボックスを
 * 含むマークアップを貼り、末尾でこのファイルを読み込む。
 *
 * 動作:
 *   - チェックが入るまで購入ボタン(#checkout / [name="checkout"])を disabled に。
 *   - 動的決済ボタンは .volca-consent-locked で操作不可（CSS の pointer-events:none）。
 *   - Dawn がカートを再描画しても再適用する（MutationObserver）。
 *   - 同意ブロックが無ければ何もしない（他ページに影響なし）。
 */
(function () {
  'use strict';

  if (window.__volcaCartConsentInit) return;
  window.__volcaCartConsentInit = true;

  var CHECKBOX_ID = 'volca-cart-consent';
  var CHECKOUT_SELECTOR = '#checkout, button[name="checkout"]';
  var DYNAMIC_SELECTOR = '.cart__dynamic-checkout-buttons, .additional-checkout-buttons';

  function getCheckbox() {
    return document.getElementById(CHECKBOX_ID);
  }

  function applyGate(allowed) {
    var locked = !allowed;

    document.querySelectorAll(CHECKOUT_SELECTOR).forEach(function (btn) {
      if (btn.disabled !== locked) btn.disabled = locked;
      btn.setAttribute('aria-disabled', String(locked));
    });

    document.querySelectorAll(DYNAMIC_SELECTOR).forEach(function (wrap) {
      wrap.classList.toggle('volca-consent-locked', locked);
      wrap.setAttribute('aria-disabled', String(locked));
    });
  }

  function sync() {
    var cb = getCheckbox();
    if (!cb) return; // 同意ブロックが無いページでは介入しない
    applyGate(cb.checked);
  }

  var scheduled = false;
  function scheduleSync() {
    if (scheduled) return;
    scheduled = true;
    (window.requestAnimationFrame || window.setTimeout)(function () {
      scheduled = false;
      sync();
    });
  }

  function init() {
    sync();

    // チェック状態の変化に追従（委譲：ブロックが後から再描画されても拾える）
    document.addEventListener('change', function (e) {
      if (e.target && e.target.id === CHECKBOX_ID) sync();
    });

    // Dawn のカート再描画（数量変更・削除等）後にゲートを再適用。
    // 監視は childList のみ＝自分が触る属性変更ではループしない。
    if (document.body && window.MutationObserver) {
      new MutationObserver(scheduleSync).observe(document.body, {
        childList: true,
        subtree: true,
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
